module.exports = __webpack_public_path__ + "img/123.95c3e8ec.jpg";